export default __webpack_public_path__ + "static/media/d19.d2ed5f46.jpeg";